import t_05_2332_b from './KZ.T.05.2332 black.svg'
import t_05_2332 from './KZ.T.05.2332.svg'
// import t_05_0294 from './t_05_0294.png'

export default [
  t_05_2332,
  t_05_2332_b
]
